import { useApi, apiResolver } from "@/api/useApi";
import {
  EnrichmentSkillConnection,
  CreateEnrichmentSkillConnectionRequest,
  UpdateEnrichmentSkillConnectionRequest,
  EnrichmentMappingContext,
} from "./EnrichmentSkillConnection.model";

export function useEnrichmentSkillConnectionApi() {
  const { api } = useApi();

  return {
    // Get skill connection for an enrichment
    getConnectionByEnrichment: async (enrichmentId: string) =>
      apiResolver<EnrichmentSkillConnection | null>(
        api.get(`/platform/enrichments/${enrichmentId}/skill-connection`)
      ),

    // Get all skill connections
    getAllConnections: async () =>
      apiResolver<EnrichmentSkillConnection[]>(
        api.get("/platform/enrichment-skill-connections")
      ),

    // Create new skill connection
    createConnection: async (request: CreateEnrichmentSkillConnectionRequest) =>
      apiResolver<EnrichmentSkillConnection>(
        api.post("/platform/enrichment-skill-connections", request)
      ),

    // Update existing skill connection
    updateConnection: async (request: UpdateEnrichmentSkillConnectionRequest) =>
      apiResolver<EnrichmentSkillConnection>(
        api.put(`/platform/enrichment-skill-connections/${request.id}`, request)
      ),

    // Delete skill connection
    deleteConnection: async (connectionId: string) =>
      apiResolver<void>(
        api.delete(`/platform/enrichment-skill-connections/${connectionId}`)
      ),

    // Toggle connection active status
    toggleConnection: async (connectionId: string) =>
      apiResolver<EnrichmentSkillConnection>(
        api.put(`/platform/enrichment-skill-connections/${connectionId}/toggle`)
      ),

    // Get mapping context for an enrichment (available fields to map)
    getMappingContext: async (enrichmentId: string) =>
      apiResolver<EnrichmentMappingContext>(
        api.get(`/platform/enrichments/${enrichmentId}/mapping-context`)
      ),

    // Test skill connection with sample data
    testConnection: async (connectionId: string, testData?: any) =>
      apiResolver<any>(
        api.post(
          `/platform/enrichment-skill-connections/${connectionId}/test`,
          testData || {}
        )
      ),
  };
}
